export const tr = {
  nav: {
    home: 'Ana Sayfa',
    treatments: 'Tedaviler',
    results: 'Sonuçlar',
    gallery: 'Galeri',
    compare: 'Karşılaştır',
    blog: 'Blog',
    locations: 'Lokasyonlar',
    contact: 'İletişim',
    bookConsultation: 'Ücretsiz Konsültasyon',
    hairAnalysis: 'Yapay Zeka Saç Analizi',
  },
  hairTransplant: {
    title: 'FUE Saç Ekimi',
    subtitle: 'Doğal görünümlü, uzun ömürlü sonuçları desteklemek üzere tasarlanan gelişmiş Foliküler Ünite Ekstraksiyonu. Bireysel sonuçlar değişkenlik gösterir.',
    bookConsultation: 'Ücretsiz Konsültasyon Al',
    viewResults: 'Sonuçları Görüntüle',
    benefits: 'Neden FUE Saç Ekimi Seçmeli?',
    process: 'FUE İşlemi Adım Adım',
    pricing: 'Şeffaf Fiyatlandırma Paketleri',
    stats: 'Sonuçlarımız',
  },
  stemcellTherapy: {
    title: 'Kök Hücre Tedavisi',
    subtitle: 'Saç restorasyonunda kök hücre araştırmalarına ilişkin bilgilendirici içerik. Uygunluk tıbbi değerlendirmeye ve yerel düzenlemelere bağlıdır.',
    benefits: 'Kök Hücre Tedavisinin Faydaları',
    howItWorks: 'Nasıl Çalışır',
    pricing: 'Kök Hücre Tedavisi Paketleri',
    idealFor: 'Kök Hücre Tedavisini Kim Düşünmeli?',
  },
  prp: {
    title: 'PRP Saç Tedavisi',
    subtitle: 'Doğal saç büyümesini teşvik etmek için Trombositten Zengin Plazma tedavisi',
    whatIs: 'PRP Saç Tedavisi Nedir?',
    benefits: 'PRP Tedavisinin Faydaları',
    procedure: 'PRP İşlemi',
    packages: 'PRP Tedavi Paketleri',
    results: 'Sonuçları Ne Zaman Beklemeli',
    idealFor: 'PRP\'yi Kim Düşünmeli?',
  },
  hero: {
    title: 'Avrupa\'da Uzman Saç Ekimi',
    subtitle: 'Türk cerrahi deneyimi ve Avrupa bakım standartlarını birleştiriyoruz. FUE ve DHI saç restorasyon uygulamaları sunuyoruz. Bireysel sonuçlar uygunluk, teknik ve bakıma göre değişir.',
    bookConsultation: 'Ücretsiz Konsültasyon Al',
    whatsapp: 'WhatsApp',
  },
  services: {
    title: 'Premium Saç Restorasyon Hizmetlerimiz',
    subtitle: 'Türk uzmanlığını Avrupa kalite standartlarıyla birleştiren ileri teknikler',
  },
  results: {
    title: 'Hasta Örnekleri ve Beklenen Süreç',
    subtitle: 'Önceki hastalardan örnek görseller. Bireysel sonuçlar donör alan, saç kaybı örüntüsü, sağlık durumu, teknik ve bakıma göre değişir.',
  },
  locations: {
    title: 'Avrupa Genelinde Konforlu Lokasyonlar',
    subtitle: 'Son teknoloji tesislerde premium bakım',
  },
  contact: {
    title: 'Saç Restorasyon Yolculuğunuza Başlayın',
    subtitle: 'Ücretsiz konsültasyonunuzu bugün ayırtın',
    name: 'Ad Soyad',
    email: 'E-posta',
    phone: 'Telefon Numarası',
    treatment: 'İlgilendiğiniz Tedavi',
    message: 'Saç dökülmesi endişelerinizi bize anlatın',
    send: 'Gönder',
    sending: 'Gönderiliyor...',
  },
  footer: {
    about: 'Hair Art Clinics, Türk tıbbi mükemmelliğini Avrupa kalite standartlarıyla birleştirerek Hollanda Den Haag\'daki kliniğinde premium saç restorasyon hizmetleri sunmaktadır.',
    quickLinks: 'Hızlı Bağlantılar',
    contactInfo: 'İletişim Bilgileri',
    followUs: 'Bizi Takip Edin',
    rights: 'Tüm hakları saklıdır.',
  },
  treatments: {
    categories: {
      hairTransplant: 'Saç Ekimi Teknikleri',
      facialHair: 'Yüz Kılı Restorasyonu',
      revision: 'Revizyon ve Düzeltme',
      nonSurgical: 'Cerrahi Olmayan Tedaviler',
      additional: 'Ek Hizmetler',
      guides: 'Bilgi ve Rehberler'
    },
    bookConsultation: 'Ücretsiz Konsültasyon Al',
    benefits: 'Faydalar',
    procedure: 'Prosedür',
    recovery: 'İyileşme Zaman Çizelgesi',
    pricing: 'Fiyatlandırma',
    faq: 'Sıkça Sorulan Sorular',
    contraindications: 'Kontrendikasyonlar',
    beforeAfter: 'Öncesi & Sonrası Sonuçlar',
    before: 'Önce',
    after: 'Sonra',
    bookingSubtitle: 'Uzmanlarımızla ücretsiz konsültasyonunuzu planlayın',
    preferredDate: 'Tercih Edilen Tarih',
    selectDate: 'Bir tarih seçin',
    bookingMessage: 'Saç endişelerinizi ve sorularınızı bize anlatın',
    submitBooking: 'Rezervasyon Talebini Gönder',
    bookingSuccess: 'Teşekkürler! Randevunuzu onaylamak için kısa süre içinde sizinle iletişime geçeceğiz.',
    category: 'Tedavi Kategorileri',
    all: 'Tüm Tedaviler',
    gallery: 'Öncesi/Sonrası Galeri',
    resultsTitle: 'Gerçek Sonuçlarımız',
    resultsSubtitle: 'Binlerce mutlu hastamızın dönüşüm hikayelerini keşfedin',
    patientStories: 'Hasta Hikayeleri',
    viewDetails: 'Detayları Görüntüle',
    grafts: 'greft',
    age: 'Yaş',
    testimonial: 'Hasta Yorumu',
    allResults: 'Tüm Sonuçlar',
    filterByProcedure: 'İşleme Göre Filtrele'
  },
  comparison: {
    title: 'FUE vs DHI vs Sapphire FUE',
    subtitle: 'Size en uygun yöntemi bulmak için saç ekimi tekniklerini karşılaştırın',
    compareTitle: 'Teknik Karşılaştırması',
    method: 'Yöntem',
    duration: 'İşlem Süresi',
    recovery: 'İyileşme Süresi',
    scarring: 'İz Oluşumu',
    density: 'Saç Yoğunluğu',
    pain: 'Ağrı Seviyesi',
    cost: 'Maliyet Aralığı',
    bestFor: 'En İyi Seçim',
    fue: {
      name: 'FUE',
      duration: '6-8 saat',
      recovery: '7-10 gün',
      scarring: 'Minimal mikro noktalar',
      density: 'Yüksek',
      pain: 'Düşük (lokal anestezi)',
      cost: '€2,500 - €4,500',
      bestFor: 'Geniş alanlar, maksimum greft'
    },
    dhi: {
      name: 'DHI',
      duration: '8-10 saat',
      recovery: '5-7 gün',
      scarring: 'Neredeyse yok',
      density: 'Çok Yüksek',
      pain: 'Minimal',
      cost: '€3,500 - €5,500',
      bestFor: 'Hassas çalışma, saç çizgisi tasarımı'
    },
    sapphire: {
      name: 'Sapphire FUE',
      duration: '6-8 saat',
      recovery: '5-7 gün',
      scarring: 'Minimal',
      density: 'Çok Yüksek',
      pain: 'Düşük',
      cost: '€3,000 - €5,000',
      bestFor: 'Doğal sonuçlar, hızlı iyileşme'
    },
    advantages: 'Temel Avantajlar',
    disadvantages: 'Dikkat Edilmesi Gerekenler',
    faqTitle: 'Sık Sorulan Sorular'
  },
  blog: {
    title: 'Saç Bakımı ve Sağlık Blogu',
    subtitle: 'Uzman görüşleri, tedavi bilgileri ve hasta başarı hikayeleri',
    categories: {
      all: 'Tüm Makaleler',
      hairHealth: 'Saç Sağlığı',
      treatmentInfo: 'Tedavi Bilgisi',
      patientStories: 'Hasta Hikayeleri',
      clinicGuides: 'Klinik Rehberleri',
      procedures: 'Prosedürler'
    },
    readMore: 'Makalenin tamamını oku',
    backToBlog: 'Bloga Dön',
    recentPosts: 'Son Yazılar',
    relatedPosts: 'İlgili Makaleler',
    publishedOn: 'Yayınlanma',
    by: 'tarafından',
    views: 'görüntülenme',
    noPostsFound: 'Makale bulunamadı',
    searchPlaceholder: 'Makale ara...',
    admin: {
      title: 'Blog Yönetimi',
      newPost: 'Yeni Makale',
      editPost: 'Makale Düzenle',
      deletePost: 'Makale Sil',
      published: 'Yayında',
      draft: 'Taslak',
      title_label: 'Başlık',
      slug_label: 'URL Slug',
      category_label: 'Kategori',
      excerpt_label: 'Özet',
      content_label: 'İçerik',
      featuredImage_label: 'Öne Çıkan Görsel URL',
      isPublished_label: 'Yayınla',
      save: 'Makaleyi Kaydet',
      cancel: 'İptal',
      deleteConfirm: 'Bu makaleyi silmek istediğinizden emin misiniz?',
      viewOnSite: 'Sitede Görüntüle'
    }
  },
  error: "Hata",
  success: "Başarılı",
  admin: {
    dashboard: 'Admin Paneli',
    overview: 'Genel bakış ve yönetim',
    whatsapp: 'WhatsApp',
    liveSupport: 'Canlı Destek',
    leadManagement: 'Lead Yönetimi',
    blogManagement: 'Blog Yönetimi',
    calendarView: 'Takvim Görünümü',
    gtmSetup: 'GTM Kurulumu',
    totalBookings: 'Toplam Randevu',
    pending: 'Bekleyen',
    confirmed: 'Onaylanan',
    cancelled: 'İptal Edilen',
    patientResults: 'Hasta Sonuçları',
    published: 'Yayında',
    thisMonth: 'Bu Ay',
    newBookings: 'Yeni randevular',
    bookingTrend: 'Randevu Trendi (Son 6 Ay)',
    monthlyStats: 'Aylık randevu istatistikleri',
    bookingStatus: 'Randevu Durumu',
    statusDistribution: 'Duruma göre dağılım',
    popularTreatments: 'Popüler Tedaviler',
    topTreatments: 'En çok talep edilen 5 tedavi',
    patientResultsManagement: 'Hasta Sonuçları Yönetimi',
    manageBeforeAfter: 'Öncesi/sonrası görselleri ve referansları yönetin',
    addNewResult: 'Yeni Sonuç Ekle',
    editResult: 'Hasta Sonucunu Düzenle',
    patientName: 'Hasta Adı',
    age: 'Yaş',
    procedureType: 'İşlem Türü',
    graftsCount: 'Greft Sayısı',
    surgeryDate: 'Ameliyat Tarihi',
    displayOrder: 'Görüntüleme Sırası',
    beforeImage: 'Öncesi Görseli',
    afterImage: 'Sonrası Görseli',
    keepCurrentImage: 'Mevcut görseli korumak için boş bırakın',
    testimonial: 'Hasta Yorumu',
    doctorNotes: 'Doktor Notları',
    publishImmediately: 'Hemen yayınla',
    cancel: 'İptal',
    uploading: 'Yükleniyor...',
    update: 'Güncelle',
    create: 'Oluştur',
    unpublish: 'Yayından Kaldır',
    publish: 'Yayınla',
    draft: 'Taslak',
    surgery: 'Ameliyat',
    order: 'Sıra',
    noResults: 'Henüz hasta sonucu yok. İlkini ekleyin!',
    deleteConfirm: 'Bu sonucu silmek istediğinizden emin misiniz?',
    leads: 'Lead Yönetimi',
    trackLeads: 'Potansiyel müşterilerinizi takip edin',
    downloadCSV: 'CSV İndir',
    totalLeads: 'Toplam Lead',
    hot: 'Sıcak',
    warm: 'Ilık',
    cold: 'Soğuk',
    converted: 'Dönüştürülen',
    sourceReport: 'Kaynak Raporu',
    conversions: 'dönüşüm',
    searchPlaceholder: 'Email, telefon veya isim ile ara...',
    allStatuses: 'Tüm Durumlar',
    new: 'Yeni',
    contacted: 'İletişime Geçildi',
    qualified: 'Nitelikli',
    lost: 'Kaybedildi',
    allSources: 'Tüm Kaynaklar',
    filterSource: 'Kaynak filtrele',
    leadList: 'Lead Listesi',
    loading: 'Yükleniyor...',
    noLeads: 'Henüz lead bulunmuyor',
    contact: 'İletişim',
    source: 'Kaynak',
    score: 'Skor',
    activities: 'Aktiviteler',
    status: 'Durum',
    date: 'Tarih',
    actions: 'İşlemler',
    pageViews: 'Sayfa Görüntüleme',
    formSubmissions: 'Form Gönderimi',
    pdfDownloads: 'PDF İndirme',
    chatInteractions: 'Chat Etkileşimi',
    leadDetail: 'Lead Detayı',
    name: 'İsim',
    email: 'Email',
    phone: 'Telefon',
    utmParams: 'UTM Parametreleri',
    notes: 'Notlar',
    saveNotes: 'Notları Kaydet',
    recentActivities: 'Son Aktiviteler',
    delete: 'Sil',
    deleteLeadConfirm: 'Bu lead\'i silmek istediğinize emin misiniz?',
    initialEmail: 'İlk Temas Email',
    followUpEmail: 'Takip Email',
    call: 'Ara',
    manualEmail: 'Manuel Email',
    bookingsCalendar: 'Randevu Takvimi',
    viewManageAppointments: 'Tüm randevuları görüntüleyin ve yönetin',
    sendReminders: 'Hatırlatıcı Gönder',
    searchByNameEmailPhone: 'İsim, email veya telefon ile ara...',
    filterByStatus: 'Duruma göre filtrele',
    allTreatments: 'Tüm Tedaviler',
    clearFilters: 'Filtreleri Temizle',
    today: 'Bugün',
    more: 'daha fazla',
    selectDate: 'Bir tarih seçin',
    noBookingsForDate: 'Bu tarih için randevu yok',
    clickToView: 'Randevuları görmek için bir tarihe tıklayın',
    reminded: 'Hatırlatıldı',
    confirm: 'Onayla',
    accessDenied: 'Erişim Engellendi',
    needAdminAccess: 'Bu sayfaya erişmek için admin yetkisi gerekiyor.',
    goHome: 'Ana Sayfaya Git',
    galleryManagement: 'Galeri Yönetimi',
    backToGallery: 'Galeriye Dön',
    uploadNewPhoto: 'Yeni Fotoğraf Yükle',
    title: 'Başlık',
    description: 'Açıklama',
    altText: 'Alt Metni (SEO için önemli)',
    treatmentPage: 'Tedavi Sayfası (Opsiyonel)',
    selectTreatment: 'Tedavi seçin (boş bırakabilirsiniz)',
    treatmentNote: 'Bu fotoğrafı belirli bir tedavi sayfasında göstermek için tedavi seçin.',
    photo: 'Fotoğraf',
    upload: 'Yükle',
    uploadedPhotos: 'Yüklenen Fotoğraflar',
    removeFromPublish: 'Yayından Kaldır',
    generalGallery: 'Genel Galeri (Tedavi seçmeyin)',
    emailTemplates: 'Email Şablonları',
    manageEmailTemplates: 'Otomatik email şablonlarını yönetin',
    newTemplate: 'Yeni Şablon',
    templateKey: 'Anahtar',
    active: 'Aktif',
    preview: 'Önizle',
    edit: 'Düzenle',
    editTemplate: 'Şablonu Düzenle',
    templateName: 'Şablon Adı',
    emailSubject: 'Email Konusu',
    htmlContent: 'HTML İçerik',
    variablesNote: 'Değişkenler: {{name}}, {{email}} kullanabilirsiniz',
    save: 'Kaydet',
    close: 'Kapat',
    createTemplate: 'Şablon Oluştur',
    templateKeyUnique: 'Şablon Anahtarı (benzersiz)',
    cms: 'İçerik Yönetimi',
    posts: 'Yazılar',
    pages: 'Sayfalar',
    media: 'Medya',
    categories: 'Kategoriler',
    settings: 'Ayarlar',
  },
  hairAnalysis: {
    title: "Yapay Zeka Saç Analizi",
    subtitle: "Fotoğrafınızı yükleyerek yapay zeka destekli ön değerlendirme alın. Bu bir ön tarama aracıdır ve nitelikli bir hekimle yapılacak muayeneyi ikame etmez.",
    uploadPhoto: "Fotoğraf Yükle",
    uploadPhotoDesc: "Analiz için saçınızın net bir fotoğrafını yükleyin",
    clickToUpload: "Görsel yüklemek için tıklayın",
    analyzeNow: "Şimdi Analiz Et",
    analyzing: "Analiz Ediliyor...",
    analysisResults: "Analiz Sonuçları",
    hairLossStage: "Saç Kaybı Evresi",
    estimatedGrafts: "Tahmini Greft Sayısı",
    recommendedTreatment: "Önerilen Tedavi",
    recommendations: "Öneriler",
    detailedAnalysis: "Detaylı Analiz",
    howItWorks: "Nasıl Çalışır",
    step1: "Saçınızın net bir ön görüntüsünü yükleyin",
    step2: "Yapay zekamız saç yoğunluğunuzu ve kayıp modelinizi analiz eder",
    step3: "Tedavi önerileriyle anında değerlendirme alın",
    step4: "Detaylı planlama için uzmanlarımızla konsültasyon rezervasyonu yapın",
    priceEstimate: "Tahmini Fiyat",
    pricePerGraft: "Greft başına fiyat",
    priceNote: "* Nihai fiyat konsültasyon sırasında belirlenecektir",
    priceRange: 'Tahmini Fiyat Aralığı',
    bookViaWhatsApp: 'WhatsApp ile Randevu Al',
    whatsappMessage: 'WhatsApp Konsültasyonu',
    getDetailedReport: 'Detaylı PDF Raporu Alın',
    reportDescription: 'Tedavi önerileri içeren kapsamlı analiz raporunu email ile alın',
    yourName: 'Adınız',
    yourEmail: 'Email Adresiniz',
    enterName: 'Adınızı girin',
    enterEmail: 'Email adresinizi girin',
    sendReport: 'Raporu Email ile Gönder',
    sending: 'Gönderiliyor...',
    reportDisclaimer: 'Tedavi planı ve fiyatlandırma içeren ücretsiz detaylı PDF rapor',
    shareResults: 'Sonuçlarınızı Paylaşın',
    shareDescription: 'Analiz sonuçlarınızı arkadaşlarınız ve ailenizle paylaşın',
    shareNote: '* Instagram: Metin panoya kopyalanacak',
  },
  auth: {
    seoTitle: 'Giriş & Kayıt - Hasta Portalı | Hair Art Clinics',
    seoDescription: 'Hair Art Clinics hasta portalınıza erişin. Tıbbi kayıtlarınızı, tedavi fotoğraflarınızı görüntülemek ve randevularınızı yönetmek için giriş yapın.',
    welcome: 'Hoş Geldiniz',
    welcomeSubtitle: 'Hasta portalına erişmek için giriş yapın veya yeni bir hesap oluşturun',
    forgotTitle: 'Şifremi Unuttum',
    forgotSubtitle: 'Sıfırlama bağlantısı almak için e-postanızı girin',
    resetTitle: 'Şifreyi Sıfırla',
    resetSubtitle: 'Yeni şifrenizi girin',
    login: 'Giriş Yap',
    signup: 'Kayıt Ol',
    email: 'E-posta',
    password: 'Şifre',
    newPassword: 'Yeni Şifre',
    confirmNewPassword: 'Yeni Şifreyi Onayla',
    confirmPassword: 'Şifreyi Onayla',
    fullName: 'Ad Soyad',
    signIn: 'Giriş Yap',
    createAccount: 'Hesap Oluştur',
    updatePassword: 'Şifreyi Güncelle',
    sendResetLink: 'Sıfırlama Bağlantısı Gönder',
    backToLogin: 'Girişe Dön',
    orContinueWith: 'Veya şununla devam et',
    continueWithGoogle: 'Google ile Devam Et',
    forgotYourPassword: 'Şifrenizi mi unuttunuz?',
  },
  clinic: {
    city: 'Lahey (Den Haag)',
    country: 'Hollanda',
    region: 'Güney Hollanda',
    hoursLabel: 'Çalışma Saatleri',
    hoursDaily: 'Her gün',
  },
};
